import { Feature } from './feature'
import { ReportExportProfile, ScanProfile } from 'app/modules/user/features/profile/types'

export enum UserNotification {
  DarkTheme = 'dark_theme',
}

export type User = {
  userId: string
  accountId: string
  username: string
  email: string
  isAdmin?: boolean
  isAuditor?: boolean
  isPasswordEmpty?: boolean
  avatarLastModified: string
  allowedFeatures?: Feature[]
  apiKey?: string
  theme?: string
  timezone?: string
  locale?: string
  feedback_notification_enabled?: boolean
  externalAuth?: {
    service: string
    userId: string
  }
  notifications?: UserNotification[]
  scanProfiles: ScanProfile[]
  reportExportProfiles: ReportExportProfile[]
}
